import React from "react"
import ReactFilter from "../../../components/inputs/ReactFilter"
import DatePicker from "react-multi-date-picker"
import Toolbar from "react-multi-date-picker/plugins/toolbar"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFilter, faCalendar } from "@fortawesome/free-solid-svg-icons"
import SearchInput from "../../../layout/SearchInput"
import dayjs from '../../../utils/dayjsConfig'
import { DATE_PICKER_SETTINGS } from '../../../delivery/constants/constants'

const AssetFilters = ({
  filters,
  resetReactFilters,
  filtersDisabled,
  allSelectedOptions,
  setAllSelectedOptions,
  selectedDates,
  handleDateFilter,
  query,
  setQuery,
  fetchData,
  searchQuery,
  filterQuery,
  dateQuery,
  resetFilters,
  searchPlaceholder
}) => {
  return (
    <>
      <h4 className="text-sub-title">Filtrar reportes por:</h4>
      <div className="filters-search-container mb-10">
        <FontAwesomeIcon className="filter-icon mr-10" icon={faFilter} />
        <div className="filters-container">
          {Array.from(filters).map((filter, indx) => (
            <div key={`flr-${indx}`} className="mr-10">
              <ReactFilter
                className="mr-10"
                title={filter.key}
                identifier={filter.key}
                options={filter.value}
                resetWatcher={resetReactFilters}
                disabled={filtersDisabled}
                onChange={(e) => {
                  let so = new Map(allSelectedOptions)
                  so.set(e.identifier, e.selectedOptions)
                  setAllSelectedOptions(so)
                }}
              />
            </div>
          ))}

          <DatePicker
            disabled={filtersDisabled}
            range
            rangeHover
            dateSeparator=" - "
            months={DATE_PICKER_SETTINGS.months}
            weekDays={DATE_PICKER_SETTINGS.weekDays}
            format="DD MMM"
            weekStartDayIndex={DATE_PICKER_SETTINGS.weekStartDayIndex}
            highlightToday={false}
            numberOfMonths={2}
            maxDate={dayjs().endOf("day").toDate()}
            onChange={(dateObjects) => handleDateFilter(dateObjects)}
            value={selectedDates}
            plugins={[
              <Toolbar
                position="bottom"
                names={{ deselect: "Deseleccionar" }}
                sort={["deselect"]}
              />
            ]}
            render={(value, openCalendar) => (
              <div
                key={`flr-date`}
                className={`mr-10 ${filtersDisabled ? "react-filter-disabled" : ""}`}
              >
                <div className="react-filter-box filter-input-width-datepicker">
                  <div
                    title="RANGO DE FECHAS"
                    onClick={!filtersDisabled ? openCalendar : undefined}
                    className="react-filter-box-clickable-zone"
                  >
                    <div className="react-filter-titles">
                      {value?.length > 0 ? (
                        <>
                          {Array.isArray(value) ? (
                            <div className="filter-title-overflow">
                              {value.join(" - ")}
                            </div>
                          ) : (
                            <div className="filter-title-overflow">{value}</div>
                          )}
                          <FontAwesomeIcon style={{ color: "ef823a" }} icon={faCalendar} />
                        </>
                      ) : (
                        <>
                          <div className="filter-title-overflow">RANGO DE FECHAS</div>
                          <FontAwesomeIcon
                            style={{
                              color: filtersDisabled ? "#D5D5D5" : "#597fa9"
                            }}
                            icon={faCalendar}
                          />
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          />
        </div>

        <div className="search-input-containter ">
          <SearchInput
            query={query}
            onSearch={(newQuery) => {
              if (newQuery === "") {
                resetFilters()
              } else {
                setQuery(newQuery)
                fetchData()
              }
            }}
            className="search-input-font"
            placeholder={searchPlaceholder}
          />
        </div>
      </div>

      <div className="mb-20">
        {(filterQuery || dateQuery || searchQuery) && (
          <a onClick={resetFilters} className="reset-filter cursor-pointer mb-20">
            Restablecer filtros aplicados
          </a>
        )}
      </div>
    </>
  )
}

export default AssetFilters
